<template>
  <div>
    <el-dialog title="新增借领" :visible.sync="editHide" :before-close="changeClose">
        <div class="journalBody">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="登记类型" prop="borrowType">
              <el-radio-group v-model="ruleForm.borrowType">
                <el-radio label="borrow">借用</el-radio>
                <el-radio label="receive">领取</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="物品名称" prop="thingName">
              <el-input v-model="ruleForm.thingName" placeholder="请输入物品名称" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="物品数量" prop="thingCount" :rules="$rules.zeroNumed">
              <el-input v-model="ruleForm.thingCount" placeholder="请输入物品数量" maxlength="8"></el-input>
            </el-form-item>
            <el-form-item label="借领日期" required>
              <el-col :span="24">
              <!-- <el-col :span="11"> -->
                <el-form-item prop="borrowTime">
                  <!-- <el-date-picker
                    type="date"
                    placeholder="请选择日期"
                    v-model="ruleForm.borrowTime"
                    style="width: 100%;"
                  ></el-date-picker> -->
                  <el-date-picker
                    v-model="ruleForm.borrowTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="请选择日期"
                    popper-class="el-date-picker"
                    style="width: 100%;"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="借领技师" prop="staffId">
              <el-select v-model="ruleForm.staffId" placeholder="请选择借领技师" class="w100s">
                  <el-option
                    v-for="(item,index) in staffList"
                    :key="index"
                    :label="item.staffName"
                    :value="item.id"
                  ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" :maxlength="100" v-model="ruleForm.remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAciton">取 消</el-button>
          <el-button type="primary" @click="trueAction('ruleForm')">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import Dialog from "../../../components/common/dialog.vue";
export default {
    data() {
      return {
        editHide: false,
        ruleForm: {
          borrowType: '',
          thingName: '',
          thingCount: '',
          borrowTime: '',
          staffId: '',
          staffName: '',
          remark: '',
        },
        rules: {
          borrowType: [
            { required: true, message: '请选择登记类型', trigger: 'change' }
          ],
          thingName: [
            { required: true, message: '请输入物品名称', trigger: 'change' },
          ],
          thingCount: [
            { required: true, message: '请输入物品数量', trigger: 'change' }
          ],
          borrowTime: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
          staffId: [
            // { type: 'array', required: true, message: '请选择借领技师', trigger: 'change' }
            { required: true, message: '请选择借领技师', trigger: 'change' }
          ],
          remark: [
            { required: false, message: '请输入备注', trigger: 'blur' }
          ]
        },
        staffList: [], //店员列表
      };
    },
    mixins: [minxin],
    components:{Dialog},
    created(){
        this.init();
        this.cardOldList();
    },
    methods: {
      init(){
          this.$on('set', function (org) {
              this.editHide = true;
          });
        },
      cardOldList() {
        this.$api.get(this.$url.companyStaff.list, {filterStatus: 'disable'}).then(res => {
          if (res) {
            this.staffList = res;
          }
        })
      },
      changeClose(show){
          this.editHide = false;
          this.ruleForm = {
            borrowType: '',
            thingName: '',
            thingCount: '',
            borrowTime: '',
            staffId: '',
            staffName: '',
            remark: '',
          };
          this.$emit('addBorrowInfo',false);
      },
      cancelAciton() {
        this.editHide = false;
      },
      trueAction() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.staffList.map((item) => {
            if (this.ruleForm.staffId == item.id) {
              this.ruleForm.staffName = item.staffName;
              }
            });
            this.$api.post(this.$url.staffBorrowInfo.save, this.ruleForm).then(res => {
              if (res) {
                this.editHide = false;
                this.ruleForm = {
                  borrowType: '',
                  thingName: '',
                  thingCount: '',
                  borrowTime: '',
                  staffId: '',
                  staffName: '',
                  remark: '',
                };
                this.$refs['ruleForm'].resetFields();
                this.$message.success("借领成功");
                this.$emit("change", true);
              }
            }).catch(error => {

            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }
  }
</script>

<style scoped lang="less">

/deep/ .el-dialog {
  margin-top: 0 !important;
  height: 560px;
  top: calc(50% - 280px);
  border-radius: 10px;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
  .bodys {
    box-sizing: border-box;
    padding: 5px 0;
    height: 410px;
  }
}

// .demo-ruleForm {
//   height: 400px;
// }

.journalBody {
  // padding: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 0px;
}
.down-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.down-img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.journaltitle {
  font-size: 19px;
  font-weight: bold;
  color: #111;
  margin-bottom: 15px;
}

.time {
  margin-top: 7.5px;
  font-size: 12px;
  color: #999;
}

.mains {
  margin-top: 32px;
  margin-left: 40px;
}
.f16 {
  font-size: 16px;
}



</style>
